/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import _ from 'lodash'
import {
  saveDescriptionOfMerchandiseField,
  saveInvoiceLineItemFeild,saveInvoiceLineItemFeildObject,
  saveDescriptionOfMerchandiseLineItem,
  deletePgaOnProgramChange,
  savePgaFlag,
  saveMerchandiseObject
} from '../api/setFormData'
import {
  sumGrossWeight,
  calculateLineItemWeightsBasedOnGrossWeightAndTotalValue,
  hasanyvaluesAdcvd,
  ch82SetHtses,
//  sumTotalValue
} from './util'
import * as actions from '../actions/actionTypes'
import {headerOption, lineItemOptions} from '../formSections/lineReason';
const initialState = {
 
}

// UPDATE functions control input, SAVE functions call API's and change dependent fields
export default function DescriptionOfMerchandiseReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    
    case 'INITIALIZE_VALUES_DESCRIPTION_OF_MERCHANDISE': {
      // Calculate and set totalLineItemWeight across line items ()
      action.payload.totalLineItemWeight = sumGrossWeight(
        action.payload.entrySummaryInvoices
      )
      return Object.assign({}, state, { ...action.payload })
    }
    case 'SET_HS_DATA_DTL': {
      //debugger;
      let newState = {...state}
      let newInvoiceItems = newState.entrySummaryInvoices.slice()
      if(newInvoiceItems.length){
        let newLineItems = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems
        let lineItem = newLineItems[action.lineItemIndex]
        if(!newLineItems[action.lineItemIndex] || !newLineItems[action.lineItemIndex].merchandiseDuties[action.dutyIndex]){
          return newState;
        }
        lineItem.merchandiseDuties[action.dutyIndex].hsDataDtl = action.payload
        if(action.dutyIndex == 0){
          lineItem.htsBasedAvailableCodes = action.availableCodes 
          lineItem.tradeProgramDetails = action.tradeProgramDetails
          lineItem.availableProductClaimCode = action.availableProductClaimCode
          lineItem.excludedCountriesGsp = action.excludedCountriesGsp  
        }
        newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex] = lineItem
        return newState;
      }
      return newState;
    }

    case 'UPDATE_TRADE_AGREEMENT_ON_COUNTRY_CHANGE': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex]
     // let newLineItems = state.merchandiseLineItems.slice()
      let countryWise = action.tradeProgramCountryMapping;
      let htsBasedAvailableCodes = lineItem.htsBasedAvailableCodes;
      let tradeProgramDetails = action.tradeProgramDetails;
      let availableProductClaimCode = action.splProgramList.filter(code => Boolean(htsBasedAvailableCodes.find((specialProgramCodes) => specialProgramCodes === code.id)))
      let countryOfOrigin = action.countryOfOrigin;
      let excludedCountriesGsp = action.excludedCountriesGsp;
      if(excludedCountriesGsp){
        excludedCountriesGsp = excludedCountriesGsp.split(',');
      }
      if(countryOfOrigin){
        availableProductClaimCode = availableProductClaimCode.filter((item)=>{
          if(countryWise[item.id]){
            let applicableCountries = countryWise[item.id].applicableCountries;
            if(excludedCountriesGsp && excludedCountriesGsp.length){
              applicableCountries = applicableCountries.filter( function( el ) {
                return excludedCountriesGsp.indexOf( el ) < 0;
              });
            }
            return applicableCountries.includes(countryOfOrigin) || item.id === 'NONE'
          }else{
            return item.id === 'NONE'
          }
        })
      }
      if(availableProductClaimCode && availableProductClaimCode[0] && availableProductClaimCode[0].id!=='NONE'){
        availableProductClaimCode.unshift({
          id: 'NA',
          description: 'Not Applicable',
          ediCode: 'NA'
        })
      }
      lineItem.availableProductClaimCode = availableProductClaimCode
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex] = lineItem
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }

    case 'UPDATE_DUTY_RATE_ON_TRADE_AGREEMENT_CHANGE': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex]
      var tradeProgramDetails = lineItem.tradeProgramDetails;
      tradeProgramDetails && (tradeProgramDetails.details||[]).map((item)=>{
        if(item.tradeProgramName == action.tradeAgreementSelected && !(["A", "A*", "A+"].includes(action.tradeAgreementSelected))){
          lineItem.merchandiseDuties[action.dutyIndex]["dutyRate"] = item.adValoremRate;
          lineItem.merchandiseDuties[action.dutyIndex]["specificRate"] = item.specifiRate;
          lineItem.merchandiseDuties[action.dutyIndex]["otherRate"] = item.otherRate;
        }
      })
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex] = lineItem
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }

    case `UPDATE_HAS_AVCVD_${action.merchandiseId}`: {
      function getcardinalityIndex(stateobject){
        var indexchoosei = 0;
        for(;indexchoosei < newstate.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties.length; indexchoosei++){
          if(stateobject.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties[indexchoosei].isCommodityDuty== 1)break;
        }
        return indexchoosei;
      }
      let newstate = state;
      var indexchoosei = getcardinalityIndex(newstate);
      let currentDuty = newstate.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties[indexchoosei];
      let oldAdcvdll = currentDuty.adcvd || {ad:{},cvd:{}};
      let newadcvd = {};
      let newadcvdforReducer = JSON.parse(JSON.stringify(oldAdcvdll));

      let pathToVariable = action.field.split('.');
      for(var targetObject of [newadcvdforReducer,newadcvd]){
        for(var iter=0;iter<pathToVariable.length;iter++){
          if(iter == pathToVariable.length -1 ){
            targetObject[pathToVariable[iter]]=action.payload;
          } else {
            targetObject[pathToVariable[iter]] = targetObject[pathToVariable[iter]] || {};
            targetObject=targetObject[pathToVariable[iter]];
          }
        }
      }
      // newadcvd.signDate= {epochs: new Date().getTime()};
      // newadcvdforReducer.signDate= {epochs: new Date().getTime()};
      var statesavedtoserver ={ entrySummaryInvoices: [{}]};
      let merchid = newstate.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseId;
      let invoiceId = newstate.entrySummaryInvoices[action.invoiceItemIndex]["invoiceId"]
      statesavedtoserver.entrySummaryInvoices[0].invoiceId = invoiceId;
      statesavedtoserver.entrySummaryInvoices[0].merchandiseLineItems=[];
      statesavedtoserver.entrySummaryInvoices[0].merchandiseLineItems[0]={}
      statesavedtoserver.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseId=merchid;
      statesavedtoserver.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseDuties=[];
      statesavedtoserver.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseDuties[0]={
        isCommodityDuty: 1,
        adcvd:newadcvd,
        merchandiseDutyId:currentDuty.merchandiseDutyId
      };
       if(action.saveafterwards){
          saveMerchandiseObject(statesavedtoserver, action.shipmentId);
       }


       newstate.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties[indexchoosei].adcvd = newadcvdforReducer;
      return newstate;

    }
    case 'UPDATE_MERCH_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'UPDATE_MERCH_LINE_ITEM_FIELD': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.index]
      lineItem[action.field] = action.payload
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.index] = lineItem
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'UPDATE_MERCH_LINE_ITEM_OBJECT': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.index]
      if(!lineItem[action.object]){
        lineItem[action.object]={};
      }
      lineItem[action.object][action.field] = action.payload
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.index] = lineItem
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'UPDATE_MERCH_LINE_ITEM_FLAG': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      window.console.log('stgfate:22 ', state,action);
      for(let oneinvoice of newInvoiceItems||[]){
        for(let oneMerch of oneinvoice?.merchandiseLineItems||[]){
          if(action.merchandiseId != oneMerch.merchandiseId)continue;
          for(let oneFlag of oneMerch?.pgaFlagInfos||[]){
            if(action.pgaGuid == oneFlag.pgaGuid){
              console.log('stgfate oneFlag: ', oneFlag, action);
              for(let oneKey of Object.keys(action.payload)){
                oneFlag[oneKey] = action.payload[oneKey]
              }
            }
          }
        }
      }
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems });
    }
    case 'UPDATE_MERCH_LINE_ITEM_PGA_OBJECT': { 
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let invoiceId = newInvoiceItems[action.invoiceItemIndex].invoiceId
      let { pgaGuid } = action;
      savePgaFlag(action.field, action.merchandiseId, action.payload, invoiceId,action.formType, pgaGuid)

      let mymerch = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems.find(a=>a.merchandiseId==action.merchandiseId);
      if(!mymerch)return state;
      let hasNoGuid = (guid) =>{
        if(!guid)return true;
        if(guid.indexOf("FAKEGUID_")>=0)return true;
        return false;
      }
      let myflags = mymerch.pgaFlagInfos.find(existingFlag=>(hasNoGuid(existingFlag.pgaGuid)?
        hasNoGuid(pgaGuid):
        pgaGuid == existingFlag.pgaGuid) && existingFlag.formType == action.formType
      )
      myflags.pgaFlagStatus = action.payload;
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'ADD_MERCHANDISE_LINE_ITEM': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItems = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems
      lineItems.push(action.newLineItem)
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems = lineItems
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'SET_MERCHANDISE_LINE_ITEM_AVAILABLE_PGA': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let newLineItems = state.merchandiseLineItems.slice()
      newLineItems.push(action.newLineItem)
      return Object.assign({}, state, { merchandiseLineItems: newLineItems })
    }
    case 'ADD_ADDITIONAL_DECLARATIONS':{
      let invoices = state.entrySummaryInvoices.slice();
      let invoice = invoices[action?.payload?.invoiceItemIndex];
      let merchandise = invoice?.merchandiseLineItems[action?.payload?.lineItemIndex];
       
      if (!merchandise.importerAdditionalDeclarationDetails) {
        merchandise.importerAdditionalDeclarationDetails = {};
      }

      if (!Array.isArray(merchandise.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail)) {
        merchandise.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail = [];
      }

      merchandise.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail.push(action?.payload?.newDeclaration);
      return Object.assign({}, state, { entrySummaryInvoices: invoices });
    }
    case 'ADD_DUTY_ITEM': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let dutyItems = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.merchIndex].merchandiseDuties
      if(ch82SetHtses.includes((action.newDuty.htsus||"").replaceAll(".",""))){
        dutyItems.splice(1,0,action.newDuty);
      } else {
        dutyItems.push(action.newDuty);
      }
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.merchIndex].merchandiseDuties = dutyItems
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'DELETE_ADDITIONAL_DECLARATIONS':{
      let invoices = state.entrySummaryInvoices.slice();
      let invoice = invoices[action?.payload?.invoiceItemIndex];
      let merchandise = invoice?.merchandiseLineItems[action?.payload?.lineItemIndex];
      merchandise.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail 
        = merchandise.importerAdditionalDeclarationDetails.importerAdditionalDeclarationDetail.filter((dec)=>dec.typeCode !== action.payload.typeCode)
      return Object.assign({}, state, { entrySummaryInvoices: invoices });
    }
    case 'UPDATE_MERCH_DUTY_ITEM_FIELD': {
      let newState = {...state}
      let newInvoiceItems = newState.entrySummaryInvoices.slice()
      let lineItems = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems
      let dutyItem = lineItems[action.lineItemIndex].merchandiseDuties[action.dutyIndex]
      if (action.field === 'htsus') {
        action.payload = action.payload.replace(/[^0-9|.]/, '')
      }
      let lineItemIndex = action.lineItemIndex;
      if(action.merchandiseId){
        lineItems.map((item, index)=>{
          if(item.merchandiseId === action.merchandiseId){
            lineItemIndex = index
          }
        })
      }
      if(!dutyItem){
        console.error("MISSING DUTYITEM! COULDN'T SAVE",action);
        console.error("MISSING DUTYITEM! COULDN'T SAVX",newState);
        return newState;
      }
      dutyItem[action.field] = action.payload
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties[action.dutyIndex] = dutyItem
      return newState;
    }
    case 'UPDATE_MERCH_DUTY_ITEM_OBJECT': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex]
      let dutyItem = lineItem.merchandiseDuties[action.dutyIndex]
      dutyItem[action.object] = {...dutyItem[action.object],[action.field]:action.payload}
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties[action.dutyIndex] = dutyItem
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'UPDATE_MERCH_OBJECT': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let newObj = Object.assign({}, state[action.object])
      newObj[action.field] = action.payload
      return Object.assign({}, state, { [action.object]: newObj })
    }
    case "DISPLAY_ERROR_MSG_ENTERED_VALUE" : {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItems = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems
      let dutyItem = lineItems[action.lineItemIndex].merchandiseDuties[action.dutyIndex]

      dutyItem["enteredValue"] = action.updatedEnteredValue
      dutyItem.displayErrorForEnteredValue= action.errorMsg
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex].merchandiseDuties[action.dutyIndex] = dutyItem
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems  })
    }
    case 'REMOVE_MERCHANDISE_LINE_ITEM': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItemsCopy = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems.slice()
      if(action.articleHeader === 'X'){
        let subComp = action.articleSubComponent
        subComp.push(action.merchandiseId);
        let newLineItems = lineItemsCopy.filter((_item)=>{
          return !subComp.includes(_item.merchandiseId)
        })
        newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems = newLineItems
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
      }else{
        lineItemsCopy.map((item)=>{
          if(item.merchandiseId === action.articleSetId){
            const index = item.articleSubComponent.indexOf(action.merchandiseId);
            if (index > -1) {
              item.articleSubComponent.splice(index, 1);
            }
          }
        })
        let newLineItems = lineItemsCopy
          .slice(0, action.index)
          .concat(lineItemsCopy.slice(action.index + 1))
          newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems = newLineItems
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
      }
     
    }
    case 'REMOVE_DUTY_ITEMS_NO_API': {
      let newInvoiceItems = JSON.parse(JSON.stringify(state.entrySummaryInvoices.slice()));
      let invoiceX = newInvoiceItems.find(invvv=>invvv.invoiceId==action.invoiceId)
      if(!invoiceX.merchandiseLineItems)return state;
      let lineItem = invoiceX.merchandiseLineItems.find(merch=> merch.merchandiseId == action.merchandiseId);
      if(!lineItem.merchandiseDuties)return state;
      
      lineItem.merchandiseDuties = lineItem.merchandiseDuties.filter(aaa=>!action.arrayOfDutyIdsToRemove.includes(aaa.merchandiseDutyId));
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'REMOVE_DUTY_ITEM': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.merchIndex]
      if(!state.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.merchIndex].merchandiseDuties)return state;
      lineItem.merchandiseDuties = (state.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.merchIndex].merchandiseDuties||[])
        .filter(a=>a.merchandiseDutyId != action.merchandiseDutyId)
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case 'SAVE_MERCHANDISE_FIELD': {
      saveDescriptionOfMerchandiseField(action.field, state[action.field])
      return state
    }
    case 'SAVE_MERCHANDISE_LINE_ITEM': {
      saveDescriptionOfMerchandiseLineItem(
        state.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.index].merchandiseId,  state.entrySummaryInvoices[action.invoiceItemIndex].invoiceId ,
        action.field,
        action.newValueQ || state.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.index][action.field],
        state.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.index]
      )
      return state
    }

    case"SAVE_INVOICE_LINE_ITEM":{
      let value = state.entrySummaryInvoices[action.invoiceItemIndex][action.field]
      if(value===""){
        value ="-999"
      }
      saveInvoiceLineItemFeild(state.entrySummaryInvoices[action.invoiceItemIndex].invoiceId ,action.field, value)
      return state
    }

    case"SAVE_INVOICE_LINE_ITEM_FRIEGHT_DATA":{

  
      saveInvoiceLineItemFeildObject(state.entrySummaryInvoices[action.invoiceItemIndex].invoiceId ,action.field1, "-999" ,action.field2, "-999" ,action.field3, "-999" )

      return state
    }
    case 'CLEAR_MERCHANDISE_LINE_ITEM': {
        state.entrySummaryInvoices[action.invoiceItemIndex].merchandiseLineItems[action.index][action.field]=null;
        return state
    }
    case 'SAVE_MERCH_DUTY_ITEM': {
      // TODO: handle error message validation from save
      return state
    }
    case 'SET_LINE_ITEM': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let newLineItems = state.merchandiseLineItems.slice()
      newLineItems[action.lineItemIndex] = action.lineItem
      return Object.assign({}, state, { merchandiseLineItems: newLineItems })
    }
    case 'SET_TOTAL_VALUE_AND_GROSS_WEIGHT': {
      // Calculate and set totalLineItemWeight across line items ()
      let totalLineItemWeight = sumGrossWeight(state.entrySummaryInvoices)
      //let totalValue = sumTotalValue(state.merchandiseLineItems)
      return Object.assign({}, state, { totalLineItemWeight })
    }
    case 'UPDATE_LINE_ITEM_WEIGHTS_BASED_ON_TOTAL_VALUE_AND_GROSS_WEIGHT': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
   //   let lineItems = state.merchandiseLineItems.slice()
      let newLineItems = calculateLineItemWeightsBasedOnGrossWeightAndTotalValue(
        state.grossWeight.weight,
        state.grossWeight.weightUnits,
      newInvoiceItems
      )
      return Object.assign({}, state, { entrySummaryInvoices: newLineItems })
    }
    case 'UPDATE_ARTICLE_SUBCOMPONENT': {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let lineItems = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems
      lineItems.map((item)=>{
        if(action.articleSetId === item.merchandiseId){
          item.articleSubComponent.push(action.merchandiseId);
        }
      })
      newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems =  lineItems
      return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case actions.UPDATE_TOTALS: {
      let otherTotalsVals_pq = action.fields.otherTotalsVals_pq; 
      const adcvdObject = _.get(otherTotalsVals_pq, "descriptionOfMerchandise.entrySummaryInvoices[0].merchandiseLineItems[0].merchandiseDuties[0].adcvd");
      let hasAnyAdcvd = hasanyvaluesAdcvd(adcvdObject,"ad") || hasanyvaluesAdcvd(adcvdObject,"cvd");
      if(hasAnyAdcvd){
        
        state = JSON.parse(JSON.stringify(state));
        var newlineitem = otherTotalsVals_pq.descriptionOfMerchandise?.entrySummaryInvoices[0]?.merchandiseLineItems[0];
        var newdutyItem = newlineitem.merchandiseDuties[0];
     
        for(var invoiceitem of state.entrySummaryInvoices){
          for( var lineitem of invoiceitem.merchandiseLineItems){
          if(lineitem.merchandiseId == newlineitem.merchandiseId){
            for(var dutyItem of lineitem.merchandiseDuties){
              if(dutyItem.merchandiseDutyId == newdutyItem.merchandiseDutyId && dutyItem.adcvd){
                if(dutyItem.adcvd.ad){
                  if(dutyItem.adcvd.ad.caseNo!='_DELETE_'){
                    if(newdutyItem.adcvd.ad && newdutyItem.adcvd.ad.dutyAmount!==undefined){
                       dutyItem.adcvd.ad.dutyAmount = newdutyItem.adcvd.ad.dutyAmount;
                    }
                  }
                }
                if(dutyItem.adcvd.cvd){
                  if(dutyItem.adcvd.cvd.caseNo!='_DELETE_'){
                    if(newdutyItem.adcvd.cvd && newdutyItem.adcvd.cvd.dutyAmount!=undefined){
                      dutyItem.adcvd.cvd.dutyAmount = newdutyItem.adcvd.cvd.dutyAmount;
                    }
                  }
                }
                break;
              }
            }
            break;
          }
        }
        }
      }
      if(otherTotalsVals_pq && otherTotalsVals_pq.descriptionOfMerchandise){
        action.fields.totalValue = otherTotalsVals_pq.descriptionOfMerchandise.totalValue;
      }

      if(otherTotalsVals_pq && otherTotalsVals_pq.descriptionOfMerchandise.entrySummaryInvoices){
        state.entrySummaryInvoices.forEach(element => {
          otherTotalsVals_pq.descriptionOfMerchandise.entrySummaryInvoices.forEach(z => {
            if(element.invoiceId ===z.invoiceId ){
              for(var key in z ){
                if(key !== "merchandiseLineItems"){
                  element[key] = z[key]
                }else{
                  element.merchandiseLineItems.forEach(merch=> {
                    z.merchandiseLineItems.forEach(record =>{
                      if(merch.merchandiseId === record.merchandiseId){
                         for( var i in record){
                            if(record.grossWeight && !record.grossWeight.weightUnits){
                              record.grossWeight.weightUnits="KG";
                            }
                           if(i !== "merchandiseDuties" ){
                             //console.log(i);
                            if(i!=='pgaFlags' && i!=='specificRate' && i!=='otherRate' && i!=='selectedFormTypes' && i!=='pgaFlagInfos' && i!== 'categoryCode' && i!='productClaimCode'){
                              //console.log(i);
                              merch[i] = record[i]
                            }
                           }else{
                            merch.merchandiseDuties.forEach(dutyObj=>{
                              record.merchandiseDuties.forEach(rdutyObj=>{
                                if(dutyObj.merchandiseDutyId === rdutyObj.merchandiseDutyId){
                                  if(merch.hasOwnProperty("articleHeader") === false){
                                    rdutyObj.enteredValue = Math.round(dutyObj.enteredValue);
                                  }
                                

                                  for(var t in rdutyObj){
                                    if(['dutyRate','specificRate','otherRate', 'manifestQuantity', 'additionalQuantity','htsus'].includes(t)){
                                      continue;
                                    }
                                    if(['adcvd'].includes(t)){
                                     for(let typee of ["cvd", "ad"]){
                                        if(dutyObj[t] && dutyObj[t][typee] && rdutyObj[t] && rdutyObj[t][typee]){
                                         dutyObj[t][typee].dutyAmount = rdutyObj[t][typee].dutyAmount;
                                        }
                                      }
                                      continue;
                                    }
                                    dutyObj[t] = rdutyObj[t]
                                  }
                                }
                              })

                            })
                           }
                         }
                      }
                    })
                  })
                }
               
              }
            }

          })
         
          
        });
      }
      delete action.fields.otherTotalsVals_pq
      return Object.assign({}, state, { ...action.fields })
    }
    case actions.UPDATE_THESE_FIELDS_TOTALS: {
      state = JSON.parse(JSON.stringify(state));
      
      let { additionalData, objWithEveryThing } = action;
      
      for(let oneKey of (additionalData.shipment_AAA||[])){
        if(objWithEveryThing.descriptionOfMerchandise[oneKey]){
          state[oneKey] = objWithEveryThing.descriptionOfMerchandise[oneKey]
        }
      }
      
      state.entrySummaryInvoices.forEach(element => {
        objWithEveryThing.descriptionOfMerchandise.entrySummaryInvoices.forEach(z => {
          if(element.invoiceId ===z.invoiceId ){
            for(var key in z ){
              if(key !== "merchandiseLineItems" && (additionalData.invoice_AAA||[]).includes(key) ){
                element[key] = z[key]
              }else{
                (element.merchandiseLineItems||[]).forEach(merch=> {
                  (z.merchandiseLineItems||[]).forEach(record =>{
                    if(merch.merchandiseId === record.merchandiseId){
                       for( var i in record){
                         if(i !== "merchandiseDuties"   && (additionalData.merchandise_AAA||[]).includes(key)  ){
                            merch[i] = record[i]
                         }else{
                          (merch.merchandiseDuties||[]).forEach(dutyObj=>{
                            (record.merchandiseDuties||[]).forEach(rdutyObj=>{
                              if(dutyObj.merchandiseDutyId === rdutyObj.merchandiseDutyId){
                                for(var tttt in rdutyObj){
                                  if( (additionalData.merchandise_AAA||[]).includes(tttt)  ){
                                   dutyObj[tttt] = rdutyObj[tttt]
                                  }
                                }
                              }
                            })

                          })
                         }
                       }
                    }
                  })
                })
              }
             
            }
          }

        })
       
        
      });
      return state;
    }
    case actions.UPDATE_HTS_CONTEXT: {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let newLineItems = state.merchandiseLineItems.slice()
      action.htsItems.forEach(item => {
        Object.assign(
          newLineItems[item.lineItemIndex].merchandiseDuties[item.dutyIndex],
          { ...item.vals }
        )
      })
      return Object.assign({}, state, { merchandiseLineItems: newLineItems })
    }
    case actions.ADD_ADDITIONAL_PGA: {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      let newLineItems = state.merchandiseLineItems.slice()
      newLineItems[action.lineItemIndex].merchandiseDuties[0].hsDataDtl.pgaRuling.push('ADD-PGA')
      return Object.assign({}, state, { merchandiseLineItems: newLineItems })
    }
    // case "SELECT_PGA": {
    //   let newInvoiceItems = state.entrySummaryInvoices.slice()
    //   let lineItem = newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex]
    //   let selectedFormType = lineItem.selectedFormTypes.slice();
    //   let applicablePga = action.pgaOptions;
    //   let deletepga = [];
    //   applicablePga.map((item)=>{
    //     let index = selectedFormType.indexOf(item.value); 
    //     if (index > -1) {
    //       selectedFormType.splice(index, 1);
    //     }
    //   })

    //   selectedFormType.push(action.formType);
    //   lineItem.selectedFormTypes = selectedFormType;
    //   newInvoiceItems[action.invoiceItemIndex].merchandiseLineItems[action.lineItemIndex] = lineItem
    //   return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    // }

    case actions.UPDATE_INVOICE_LINE_ITEM_FIELD: {
      let newInvoiceItems = state.entrySummaryInvoices.slice()
      newInvoiceItems[action.index][action.field] =action.payload
       return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
    }
    case actions.REMOVE_INVOICE_LINE_ITEM: {
      let lineItemsCopy = state.entrySummaryInvoices.slice();
      lineItemsCopy = lineItemsCopy.filter((item) => {
        return item.invoiceId !== action.invoiceId;
      });
      return Object.assign({}, state, { entrySummaryInvoices: lineItemsCopy });
    }
    case actions.ADD_INVOICE_ITEM: {
      let newInvoiceList = state.entrySummaryInvoices.slice()
        if(action.newInvoiceItem){
          newInvoiceList.push(action.newInvoiceItem);
        }
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceList });
      }

      case "SHOW_LOADER" : {
        let newInvoiceItems = state.entrySummaryInvoices.slice()
        newInvoiceItems[action.invoiceItemIndex].showLoader = true
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
        
      }
      case "HIDE_LOADER" : {
        let newInvoiceItems = state.entrySummaryInvoices.slice()
        newInvoiceItems[action.invoiceItemIndex].showLoader = false
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
      }

      case "HIDE_UNHIDE_INVOICE" : {
        let newInvoiceItems = state.entrySummaryInvoices.slice()
        newInvoiceItems[action.invoiceItemIndex].expandInvoiceItem = true
      // for(let i  = 0 ; i < newInvoiceItems.length ;i++ ){
      //     if(i !== action.invoiceItemIndex){
      //       newInvoiceItems[i].expandInvoiceItem = false
      //     }
      // }
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
      }
      case "HIDE_INVOICE" : {
        let newInvoiceItems = state.entrySummaryInvoices.slice()
        newInvoiceItems[action.invoiceItemIndex].expandInvoiceItem = false
 
        return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
      }
      case "UPDATE_TARIFFS": {
        const { invoiceId, merchandiseId, updatedDuties } = action.payload;
        return {
          ...state,
          entrySummaryInvoices: state.entrySummaryInvoices?.map((invoice) => {
            if (invoice?.invoiceId !== invoiceId) return invoice;
    
            return {
              ...invoice,
              merchandiseLineItems: invoice.merchandiseLineItems?.map((item) => {
                if (item?.merchandiseId !== merchandiseId) return item;
                const preservedDuties = item.merchandiseDuties?.filter(
                  (duty) => duty.isCommodityDuty === 1
                ) || [];
      
                return {
                  ...item,
                  merchandiseDuties: [...preservedDuties, ...updatedDuties],
                };
              }),
            };
          }),
        };
      } 
      case  "TARIFFS_LOADER": {
        return{
          ...state,
          tariffsLoader:  action.payload
        }
      }   
      case actions.UPDATE_ADDITION_DEDUCTION: {
        const { descriptionOfMerchandise = {},hmf,mpf,grandTotal } = action.data || {};
      const {entrySummaryInvoices=[],totalDeletions,totalAdditions,totalValue}=descriptionOfMerchandise
        return {
          ...state,
          hmf:{...(state.hmf || {}),...(hmf || {})},
          mpf:{...(state.mpf || {}),...(mpf || {})},
          grandTotal:grandTotal,
          totalDeletions:totalDeletions || state.totalDeletions ,
          totalAdditions:totalAdditions || state.totalAdditions,
          totalValue,
          entrySummaryInvoices: state.entrySummaryInvoices.map((item) => {
            const checkIfInvoiceidExist = entrySummaryInvoices.find(
              (c) => c.invoiceId === item.invoiceId
            );
      
            if (checkIfInvoiceidExist) {
              const {
                merchandiseLineItems: newMerchandiseLineItems = [],
                ...restData
              } = checkIfInvoiceidExist || {};
      
              const updatedMerchandiseItem = (item.merchandiseLineItems || []).map((currentItem) => {
                const checkIfMerchandiseExist = newMerchandiseLineItems.find(
                  (c) => c.merchandiseId === currentItem.merchandiseId
                );
      
                if (checkIfMerchandiseExist) {
                  const updatedMerchandiseDuty = (currentItem.merchandiseDuties || []).map((currentDutyItem) => {
                    const checkIfMerchandiseDutyExist = (checkIfMerchandiseExist.merchandiseDuties || []).find(
                      (c) => c.merchandiseDutyId === currentDutyItem.merchandiseDutyId
                    );
      
                    if (checkIfMerchandiseDutyExist) {
                      return { ...currentDutyItem, enteredValue:checkIfMerchandiseDutyExist.enteredValue,duty:checkIfMerchandiseDutyExist.duty,additions:{...(currentDutyItem.additions || {}),...(checkIfMerchandiseDutyExist.additions || {})},deletions:{...(currentDutyItem.deletions || {}),...(checkIfMerchandiseDutyExist.deletions || {})},invoiceCurrencyValue:checkIfMerchandiseDutyExist.invoiceCurrencyValue,adjustedValue:checkIfMerchandiseDutyExist.adjustedValue,hmf:{...(currentDutyItem.hmf || {}),...(checkIfMerchandiseDutyExist.hmf || {})},mpf:{...(currentDutyItem.mpf || {}),...(checkIfMerchandiseDutyExist.mpf || {})} };
                    }
      
                    return currentDutyItem;
                  });
      
                  return {
                    ...currentItem,
                    merchandiseDuties: updatedMerchandiseDuty,
                  };
                }
      
                return currentItem;
              });
      
              return {
                ...item,
                totalEnteredValue:restData.totalEnteredValue,
                otherAdditions:restData.otherAdditions || item.otherAdditions ,
                otherDeductions:restData.otherDeductions || item.otherDeductions,
                invoiceAmount:restData.invoiceAmount || item.invoiceAmount,
                totalAdditions:restData.totalAdditions || item.totalAdditions,
                totalDeletions:restData.totalDeletions || item.totalDeletions,
              //  ...restData,
                merchandiseLineItems: updatedMerchandiseItem,
              };
            }
            return item;
          }),
        };
      }
       
      
       
      // case "HIDE_UNHIDE_FRIEGHTDATA" : {
      //   let newInvoiceItems = state.entrySummaryInvoices.slice()
      //   newInvoiceItems[action.invoiceItemIndex].showFrightData = action.payload
 
      //   return Object.assign({}, state, { entrySummaryInvoices: newInvoiceItems })
      // }
    default:
      return state
  }
}